import axios from 'axios';

// Set base URL from environment variable - check various possible Vue CLI and Vite env vars
const apiBaseUrl = process.env.API_URL || process.env.VUE_APP_API_URL || process.env.VITE_API_URL;
console.log('API Base URL:', apiBaseUrl);
console.log('process.env.API_URL:', process.env.API_URL);
console.log('process.env.VUE_APP_API_URL:', process.env.VUE_APP_API_URL);
console.log('process.env.VITE_API_URL:', process.env.VITE_API_URL);

const apiClient = axios.create({
  baseURL: apiBaseUrl,
  headers: {
    'Content-Type': 'application/json',
  },
});

export default apiClient;
